import { render, staticRenderFns } from "./CommentDmDialog.vue?vue&type=template&id=55acb7db&scoped=true"
import script from "./CommentDmDialog.vue?vue&type=script&lang=js"
export * from "./CommentDmDialog.vue?vue&type=script&lang=js"
import style0 from "./CommentDmDialog.vue?vue&type=style&index=0&id=55acb7db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55acb7db",
  null
  
)

export default component.exports